var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1346_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2345 27.4341C16.3857 27.2829 16.5911 27.1986 16.8049 27.1998L32.7862 27.2931C34.1257 27.2931 35.2002 26.2186 35.2002 24.8931V8.79981C35.2002 7.47432 34.1257 6.3998 32.8002 6.3998H7.2002C5.87471 6.3998 4.8002 7.47432 4.8002 8.79981V24.8553C4.82377 26.2226 5.91693 27.2782 7.24221 27.255L10.3862 27.1999C10.8334 27.1921 11.2002 27.5525 11.2002 27.9998V32.4684L16.2345 27.4341ZM9.60019 28.8139L7.27022 28.8547C5.06142 28.8934 3.23948 27.1342 3.20081 24.9254C3.20047 24.902 3.20026 19.5268 3.2002 8.79981C3.2002 6.59067 4.99106 4.7998 7.2002 4.7998H32.8002C35.0093 4.7998 36.8002 6.59067 36.8002 8.79981V24.8931C36.8002 27.1023 35.0093 28.8931 32.8002 28.8931C32.7924 28.8931 27.5689 28.8627 17.1296 28.8017L10.9659 34.9655C10.4619 35.4695 9.60019 35.1125 9.60019 34.3998V28.8139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 15.9994C11.5584 15.9994 11.2002 15.6412 11.2002 15.1994C11.2002 14.7576 11.5584 14.3994 12.0002 14.3994H26.4002C26.842 14.3994 27.2002 14.7576 27.2002 15.1994C27.2002 15.6412 26.842 15.9994 26.4002 15.9994H12.0002ZM12.0002 20.7994C11.5584 20.7994 11.2002 20.4412 11.2002 19.9994C11.2002 19.5576 11.5584 19.1994 12.0002 19.1994H23.2002C23.642 19.1994 24.0002 19.5576 24.0002 19.9994C24.0002 20.4412 23.642 20.7994 23.2002 20.7994H12.0002Z",
    fill: "#D4EAF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1346_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.00ad51f91e4d7d497ec98a1ae62640c3.svg";
export { ForwardRef as ReactComponent };